import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";
import moment from "moment";
import DownloadPopup from "../App/DownloadPopup";
import DragDrop from "../DragDrop/DragDrop";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
function Input() {
  const [selectedId, setSelectedId] = useState({
    Years: 2023,
    Months: 8,
  });

  const [inputFiltersData, setInputFiltersData] = useState({
    Years: [],
    Months: [],
  });

  const [factorScoreFileLogsData, setFactorScoreFileLogsData] = useState([]);

  const [showAnimation, setShowAnimation] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully.!"
  );

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: 1,
    MaxAllowedFiles: 1,
    UploadType: 4,
    FolderName: "REP",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);

  useEffect(() => {
    getLoadFilters();
  }, [selectedId.Years]);

  useEffect(() => {
    getFactorScoreFileLogs();
  }, [selectedId.Months]);

  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  function getLoadFilters() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.dealerid = 0;
    object.year = selectedId.Years;
    object.sc = 0;
    object.sdid = 0;
    object.sfid = 0;
    object.sbid = 0;
    object.syid = selectedId.Years;
    object.smid = selectedId.Months;
    axiosAuth
      .post(AppContext.AppBaseURL + "api/PFIRSFactorKey/GetLoadFilters", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setInputFiltersData((prevState: any) => ({
            ...prevState,
            Years: l_response[3],
            Months: l_response[4],
          }));

          if (l_response[0]) {
            selectedId.Years = l_response[0][0].SelectedYear;
            selectedId.Months = l_response[0][0].SelectedMonth;
          }
          getFactorScoreFileLogs();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getFactorScoreFileLogs() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/GetFactorScoreFileLogs",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setFactorScoreFileLogsData(l_response[0]);
          ReadToken();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getInputFactorBulkUploadTemplatedFile() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetInputFactorBulkUploadTemplatedFile",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpMessage("Data has been exported to file successfully.!")
            setPopUpFileURL(link);
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function SaveFiles() {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = 1;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            savedBulkFactorsData(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
          setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      //saveConactUsData([]);
    }
  }

  function savedBulkFactorsData(p_S3UploadFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.filesdata = p_S3UploadFileList;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/GetSavedBulkFactorsData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].LogFile;
          if (l_response[0][0].Status === 1) {
            let DisplayMessage =
              "Data has been imported. <br> Number of records: " +
              l_response[0][0].TotalRecords +
              "<br> Error in records: " +
              l_response[0][0].ErrorRecords;
            setPopUpMessage(DisplayMessage);
            setPopUpFileURL(link);
            setShowPopUp(true);
            getFactorScoreFileLogs();
          } else {
            alert(l_response[0][0].Message);
          }
          setShowAnimation(false);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }



  function ReadToken() {
    let object = {} as any;
    axiosAuth
      .post(AppContext.AppBaseURL + "api/PFIRSFactorKey/PTLGfnGtTknDt", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data;
          console.log(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <>
    {showAnimation && <LoadingAnimation/> }
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Input</a>
        </div>
        <DownloadPopup
          ShowPopup={showPopUp}
          FileLink={popUpFileURL}
          Message={popUpMessage}
          DownloadPopupCallBack={DownloadPopupCallBack}
        />

        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items justify-btw width-100">
              <div className="select-space">
                <select
                  className="input-field select-field"
                  value={selectedId.Years}
                  onChange={(e) =>
                    setSelectedId((prevState: any) => ({
                      ...prevState,
                      Years: e.target.value,
                    }))
                  }
                >
                  {inputFiltersData.Years &&
                    inputFiltersData.Years.map((Item: any, index) => (
                      <option value={Item.PID} key={"Years" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
                <select
                  className="input-field select-field"
                  value={selectedId.Months}
                  onChange={(e) =>
                    setSelectedId((prevState: any) => ({
                      ...prevState,
                      Months: e.target.value,
                    }))
                  }
                >
                  {inputFiltersData.Months &&
                    inputFiltersData.Months.map((Item: any, index) => (
                      <option value={Item.PID} key={"Months" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="centre-drop-cl">
                <div className="drad-drop">
                  <DragDrop
                    ParentFeatures={dragDropFeatures}
                    DragDropCallback={handleDragDropCallback}
                    TriggerChild={triggerChild}
                  />
                </div>
                <div className="help-btns">
                  <a onClick={() => SaveFiles()}>Upload</a>
                </div>
              </div>
              <a
                className="download-input"
                onClick={() => getInputFactorBulkUploadTemplatedFile()}
              >
                Download Input File
              </a>
            </div>
          </div>

          <div className="section-table">
            <table className="part-head trend-table fixed-table" id="tblData">
              <thead>
                <tr>
                  <th>Uploaded By</th>
                  <th>Dated</th>
                  <th>Data File</th>
                  <th>Log File</th>
                </tr>
              </thead>
              <tbody>
                {factorScoreFileLogsData &&
                  factorScoreFileLogsData.map((item: any, index: any) => (
                    <React.Fragment key={"Main" + index}>
                      <tr>
                        <td>{item.Name}</td>
                        <td>
                          {moment(item.Dated).format("MM/DD/YYYY hh:mm:ss a")}
                        </td>
                        <td>
                          <a
                            className="input-view"
                            href={item.FileData}
                            target="blank"
                          >
                            View
                          </a>
                        </td>
                        <td>
                          <a
                            className="input-view"
                            href={item.LogFileData}
                            target="blank"
                          >
                            View
                          </a>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Input;
